import { MailAccount } from '@/types/dashboard/mail'

export const CART_DUMMY_ID = '15fdd54b-8ab5-431a-982f-1e79b8614ed3' // Shopping-Cart Dummy ID
// Pause before retrying a cart write the backend refused as contended. It fails
// fast under NOWAIT rather than queueing behind an in-flight checkout, so the
// retry is the other half of that bargain.
export const CART_BUSY_RETRY_MS = 400

// REGEX - Note: Do NOT use /g flag with .test() as it causes stateful behavior
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// TODO: FIX REGEX
export const DOMAIN_REGEX = new RegExp(
  /^([A-Z\s&‘@*(),.!?_#^:\\/;%+=<>$¢£¤¥֏؋৲৳৻૱௹฿៛\u20a0-\u20bd\ua838\ufdfc\ufe69\uff04\uffe0\uffe1\uffe5\uffe6]+)([^.\w]+)$/g
)

export const SUPPORTED_COUNTRIES = ['Deutschland']

/**
 * The company phone number, in the formats the various surfaces print it in.
 * Single source because it is published in the Impressum, the AGB and the
 * Widerrufsbelehrung, so a partial update is a defect in text customers are
 * asked to accept.
 *
 * The 03682 area code is Zella-Mehlis rather than the Aachen seat: the former
 * Suhl line was already out of service and the provider has not yet assigned a
 * number for the new address, so this one stands in until it does. It is
 * expected to change again, which is why it lives in one place.
 *
 * `public/llms.txt` and the legal i18n strings cannot import this: the first is
 * a static asset, the second is translated prose. `contactDetails.spec.ts`
 * holds them to the value below instead.
 */
export const COMPANY_PHONE = {
  /** Dialable, for `tel:` hrefs and schema.org. */
  e164: '+4936829180648',
  /** Default display form. */
  display: '+49 3682 9180648',
  /** With the national trunk prefix, as the legal pages show it. */
  national: '+49 (0)3682 9180648',
  /** Print stylesheet footer. */
  print: '+493682 / 9180648',
  /** schema.org `telephone`, hyphenated. */
  jsonLd: '+49-3682-9180648'
} as const

// The webmail client for every mailbox. The portal's own /webmail route is the
// mailbox settings page, not a mail client.
export const WEBMAIL_URL = 'https://webmail.itsh.dev'

export const ALIAS_MAIL = {
  Mail: MailAccount.shape.type.enum.mailbox,
  Alias: MailAccount.shape.type.enum.alias
}

export enum STATUS_CODES {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  GONE = 410,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  PRECONDITION_REQUIRED = 428,
  TOO_MANY_REQUESTS = 429,
  ALREADY_EXISTS = 460,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504
}

export const TOP_TLDS = ['de', 'com', 'org', 'info', 'net', 'eu', 'at', 'ch', 'dev']

export const GERMAN_STATES = [
  'Baden-Württemberg',
  'Bayern',
  'Berlin',
  'Brandenburg',
  'Bremen',
  'Hamburg',
  'Hessen',
  'Mecklenburg-Vorpommern',
  'Niedersachsen',
  'Nordrhein-Westfalen',
  'Rheinland-Pfalz',
  'Saarland',
  'Sachsen',
  'Sachsen-Anhalt',
  'Schleswig-Holstein',
  'Thüringen'
]

export const PHP_VERSIONS = [
  {
    version: '8_0',
    name: '8.0'
  },
  {
    version: '8_1',
    name: '8.1'
  },
  {
    version: '8_2',
    name: '8.2'
  }
]

export enum PayIntervalEnum {
  monthly = 'monatlich',
  quarterly = 'quartalsweise',
  'half-annually' = 'halbjährlich',
  annually = 'jährlich',
  free = 'kostenlos'
}

export const PayIntervals = [
  {
    key: 'monthly',
    value: 'monatlich'
  },
  {
    key: 'quarterly',
    value: 'quartalsweise'
  },
  {
    key: 'half-annually',
    value: 'halbjährlich'
  },
  {
    key: 'annually',
    value: 'jährlich'
  }
]
